import { BaseActionType, SET_CONFIG } from '../actions/actionTypes'

import { ConfigurationState } from './initialState'

const initialConfigState: ConfigurationState | null = null

export function configReducer(
  state = initialConfigState,
  action: BaseActionType,
): ConfigurationState | null {
  switch (action.type) {
    case SET_CONFIG: {
      return action.payload as ConfigurationState
    }
    default:
      return state
  }
}
